<app-menu>
  <div class="container">
    <div class="row mt-1">
      <div class="col-sm-12 filter-box">
        <span class="title-box">
            Relatório Posição de Pagamento Decendial
        </span>
        <form class="col-12 mt-3 form-box">
          <div class="form-row">
            <div class="form-group col-md-4 col-sm-12">
              <label class="filter-label"> Instituição Financeira <b class="text-danger">*</b> </label>
              <input
                [(ngModel)]="query.instituicao"
                [ngModelOptions]="{standalone: true}"
                placeholder="Digite o Nome da Instituição Financeira"
                list="instituicoes"
                type="text"
                class="form-control">
              <datalist name="instituicoes" id="instituicoes">
                <option *ngFor="let option of tableInstituicao" [value]="option.nome"> {{ option.nome }}</option>
              </datalist>
            </div>
            <div class="form-group col-md-4 col-sm-12">
              <label class="filter-label"> Mês/Ano <b class="text-danger">*</b></label>
              <input
                [(ngModel)]="dataComp"
                placeholder="Ex: yyyy/mm"
                [ngModelOptions]="{ standalone: true }"
                type="month"
                class="form-control" />
            </div>
            <div class="form-group col-md-4 col-sm-12">
              <label class="filter-label"> Decêndio <b class="text-danger">*</b> </label>
              <select
                [(ngModel)]="query.decendio"
                [ngModelOptions]="{standalone: true}"
                name="decendio"
                class="form-control">
                  <option selected value="">Selecione uma das opções</option>
                  <option *ngFor="let option of tableDecendio" [value]="option.idDecendio">
                    {{ option.desDecendio }}
                  </option>
              </select>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-4 col-sm-12">
              <label class="filter-label">Nome da Corretora</label>
              <input
                [(ngModel)]="query.corretora"
                [ngModelOptions]="{standalone: true}"
                type="text"
                class="form-control"
                placeholder="Digite o nome da Corretora">
            </div>
            <div class="form-group col-md-4 col-sm-12" *ngIf="tipoUsuario == 'LIQUIDANTE'">
              <label class="filter-label"> Investimento <b class="text-danger">*</b> </label>
              <select
                [(ngModel)]="query.investimento"
                [ngModelOptions]="{standalone: true}"
                name="investimento"
                class="form-control">
                  <option selected value="todos">Todos</option>
                  <option selected value="direto">Direto</option>
                  <option selected value="indireto">Indireto</option>
              </select>
            </div>
            <div class="form-group col-md-4 col-sm-12">
              <label class="filter-label">CPF/CNPJ <i
                class="fas fa-info-circle"
                mdbTooltip="É necessário preencher o CPF/CNPJ ou o Termo / Nº de controle para realizar a pesquisa"
                placement="top"></i></label>
              <input
                [(ngModel)]="query.documentoIdentificador"
                [ngModelOptions]="{ standalone: true }"
                type="text"
                class="form-control"
                [mask]="getCpfCnpjMask()"
                (input)="onCpfCnpjInput($event)"
                (paste)="onCpfCnpjPaste($event)"
                (keydown)="onCpfCnpjKeyDown($event)"
                placeholder="Digite o CPF/CNPJ" />
            </div>
            <div class="form-group col-md-4 col-sm-12">
              <label class="filter-label">Termo/Nº de Controle <i
                class="fas fa-info-circle"
                mdbTooltip="É necessário preencher o CPF/CNPJ ou o Termo / Nº de controle para realizar a pesquisa"
                placement="top"></i>
              </label>
              <input
                [(ngModel)]="query.codigoTermo"
                [ngModelOptions]="{ standalone: true }"
                type="text"
                class="form-control"
                placeholder="Digite o Termo/Nº de Controle" />
            </div>
          </div>
          <div class="form-row">
            <span (click)="expandir.toggle()" class="expand-btn pt-3">
                Filtros Avançados <i class="fas fa-caret-down"></i>
            </span>
          </div>
          <div mdbCollapse #expandir="bs-collapse">
            <div class="form-row mt-3 p-2">
              <div class="form-group col-md-4 col-sm-12">
                <label class="filter-label">Ordenar Registros</label>
                <select [(ngModel)]="query.sortBy" [ngModelOptions]="{standalone: true}" class="form-control" name="sortBy">
                  <option value="instituicao">Instituição Financeira</option>
                  <option value="corretora">Nome Corretora</option>
                  <option value="razaoSocial">Nome/Razão Social Investidor</option>
                  <option value="documentoIdentificador">CPF/CNPJ</option>
                  <option value="termo">Termo/Nº de Controle</option>
                  <option value="valorIRRF">Valor do IRRF</option>
                  <option value="valorTotal">Valor Total a Pagar</option>
                  <option value="dataPagamento">Data Pagamento</option>
                </select>
              </div>
              <div class="form-group col-md-4 col-sm-12">
                <label class="filter-label">Ordem de Ordenação</label>
                <select [(ngModel)]="query.orderBy" [ngModelOptions]="{standalone: true}" name="sortBy" class="form-control">
                  <option value="asc">Ascendente</option>
                  <option value="desc">Decrescente</option>
                </select>
              </div>
            </div>
          </div>
          <div class="d-flex mt-5">
            <button (click)="exportarExcel()" *ngIf=" userHasAcessToResource(3086)" class="btn">Exportar Excel</button>
            <button
              (click)="pesquisar(1)"
              [disabled]="!canSearch()"
              [ngClass]="{'btn-disabled': !canSearch()}"
              class="btn ml-3">Pesquisar</button>
          </div>
        </form>
      </div>
    </div>
    <div class="row mt-3">
      <div *ngIf="this.exibir" class="filter-box p-5">
        <label class="text-danger"> {{ messageErro }} </label>
      </div>
    <div *ngIf="!this.exibir && this.exibirTabela" class="filter-box">
      <table class="table">
        <thead id="custom">
          <tr>
            <th>Instituição Financeira</th>
            <th>Nome Corretora</th>
            <th>Nome/Razão Social Investidor</th>
            <th>CPF/CNPJ</th>
            <th>Termo/Nº de Controle</th>
            <th>Valor do IRRF</th>
            <th>Valor IOF</th>
            <th>Valor Total a Pagar</th>
            <th>Data Pagamento</th>
          </tr>
        </thead>
          <tbody>
            <tr *ngFor="let data of tableData | paginate: {
                itemsPerPage: query?.pageSize,
                currentPage: query?.page,
                totalItems: paginacaoData!.totalRegistros
              }" class="mdbTableCol">
              <td> {{ data.instituicao }} </td>
              <td> {{ data.corretora }} </td>
              <td> {{ data.nomeInvestidor }} </td>
              <td *ngIf="tipoUsuario != 'LIQUIDANTE'"> {{ data.corretora }} </td>
              <td *ngIf="data.documentoIdentificador.length < 13">
                  {{ data.documentoIdentificador | mask: "AAA.AAA.AAA-AA"}}
              </td>
              <td *ngIf="data.documentoIdentificador.length > 13">
                  {{ data.documentoIdentificador | mask: "AA.AAA.AAA/AAAA-AA"}}
              </td>
              <td> {{ data.termoCodigoAtivo }} </td>
              <td> {{ data.valorIRRF | currency: 'BRL' }} </td>
              <td> {{ data.valorIof | currency: 'BRL' }} </td>
              <td> {{ data.valorTotal | currency: 'BRL' }} </td>
              <td> {{ data.dtPagamentoCredor }} </td>
            </tr>
          </tbody>
      </table>
    </div>
    <div class="row mt-5 col-12 mt-3 d-flex justify-content-center">
      <div class="col-md-12">
        <pagination-controls
          responsive="true"
          (pageChange)="proximaPagina($event)"
          *ngIf="this.tableData.length >= 1"
          nextLabel="Próximo"
          previousLabel="Anterior"
          directionLinks="true"
          class="fgc-pagination"
        >
        </pagination-controls>
      </div>
    </div>
    </div>
  </div>
  <div class="modal-backdrop" *ngIf="progresso.exibe"></div>

  <div class="modal" tabindex="-1" role="dialog" *ngIf="progresso.exibe">
    <div class="modal-dialog modal-dialog-centered custom-size" role="document">
      <div class="modal-content p-4 text-center">

        <div class="d-flex justify-content-center mb-3">
          <div class="spinner-border text-success" role="status">
          </div>
        </div>

        <h4 class="modal-title mb-4">
          Seu relatório está sendo gerado.
        </h4>
        <h5 class="modal-title mb-4">
          Este processo pode levar alguns minutos. Por favor, não feche a janela enquanto o carregamento estiver em andamento.
        </h5>

        <div class="progress">
          <div
            class="progress-bar bg-primary"
            role="progressbar"
            [style.width.%]="progresso.valor"
            aria-valuemin="0"
            aria-valuemax="100">
            {{ progresso.valor }}%
          </div>
        </div>

        <div class="mt-3 text-center">
          <button class="btn btn-danger" (click)="onCancel()">Cancelar</button>
        </div>
      </div>
    </div>
  </div>
</app-menu>
